import { h } from 'preact';
import 'jquery-file-download';
import store from '../../store';
import * as actions from "../../actions";
import { MobileMenuRoutes } from "./MobileAppMenu";
import EditIcon from "../icon/EditIcon";
import { updateElementAttribute } from '../../actions';
import SaveModal from "../SaveModal";
import { useState } from "preact/hooks";
import util, { toLogIn } from '../../util';
import PublishChangesButton from '../header/PublishChangesButton';
import LoadingSpinner from '../LoadingSpinner';
import designService from '../../service/designService';
import Renderer from '../../canvas/renderer';
import { ArrowsAltOutlined, ClockCircleOutlined, DownloadOutlined, LoadingOutlined, MessageOutlined, QuestionCircleOutlined, ShareAltOutlined } from '@ant-design/icons';
import constants from '../../constants';

const SAVE_DESIGN = 'Save this Design';
const RENAME_DESIGN = 'Rename this Design';

export default function MenuRoot({ isLogged, width, height, unit, name, setView, isSocialDesign, isA4, isLogo, isDigitalMenuBoard, isCustomSize,
  toggleMenu, websiteToken, designName, designId, designSize, parentId, lastSavedTag, showPublishChanges, showPublishChangesDSA, showPublishWarningBanner }) {

  const [isSaveModal, setIsSaveModal] = useState(false);
  const [saveModalTitle, setSaveModalTitle] = useState('');
  const [saveModalMode, setSaveModalMode] = useState('');

  const [isPublishing, setIsPublishing] = useState(false);

  const [savingBeforePrint, setSavingBeforePrint] = useState(false);

  function save(title) {
    if (!isLogged) {
      toLogIn();
      return;
    }

    setSaveModalTitle(title);
    setSaveModalMode('design');
    setIsSaveModal(true);
  }

  function onSaveSuccess() {
    setIsSaveModal(false);
    toggleMenu();
  }

  function openChat() {
    Intercom('showNewMessage');
  }

  function goToPrint() {
    store.dispatch(actions.setReplaceFrameMode(false));
    store.dispatch(actions.deselect());
    setSavingBeforePrint(true);

    designService.updateDesign({
      id: designId,
      templateId: parentId,
      name: designName,
      html: Renderer.getPagesContent(),
      size: designSize,
      lastSavedTag: lastSavedTag,
      hasChanges: true,
    }).then((resp) => {
      if (resp.data.success) {
        toggleMenu();
        store.dispatch(actions.goToView('print'));
      } else {
        util.showDesignInUseModal();
      }
      setSavingBeforePrint(false);
    }).catch((err) => {
      console.log(err);
      setSavingBeforePrint(false);
    })
  };

  return (
    <div>
      <header className={'mn'}>
        <h2>
          {name}
          <a onClick={() => save(RENAME_DESIGN)}>
            <EditIcon />
          </a>
        </h2>
        <h6>{width} x {height} {unit}</h6>
      </header>
      <div className={'main-menu-options'}>
        {showPublishChanges &&
          <div>
            <PublishChangesButton designId={designId} updateElementAttribute={updateElementAttribute} websiteToken={websiteToken} isMobile={true} showPublishWarningBanner={showPublishWarningBanner} />
          </div>}
        {showPublishChangesDSA &&
          <div>
            <PublishChangesButton designId={designId} updateElementAttribute={updateElementAttribute} websiteToken={websiteToken}
              isMobile={true} dsa={true} showPublishWarningBanner={showPublishWarningBanner} />
          </div>}
        <ul className={'main'}>
          <li onClick={() => save(SAVE_DESIGN)}>
            <div className='svg-cont'>
              <svg>
                <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-cloud-icon"} />
              </svg>
            </div>
            Save
          </li>
          <li onClick={() => setView(MobileMenuRoutes.copy)}>
            <div className='svg-cont'>
              <svg>
                <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-copy-file-icon"} />
              </svg>
            </div>
            Make a Copy
          </li>
          <li onClick={() => setView(MobileMenuRoutes.resize)}>
            <ArrowsAltOutlined />
            Resize
          </li>
          <li onClick={() => setView(MobileMenuRoutes.revisions)}>
            <div className='svg-cont'>
              <svg>
                <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-history-icon"} />
              </svg>
            </div>
            See Version History
          </li>
        </ul>
        <div className={'menu-separator'}></div>
        <ul className={'main'}>
          <li onClick={() => setView(MobileMenuRoutes.download)}>
            <DownloadOutlined />
            Download
          </li>
          <li onClick={() => setView(MobileMenuRoutes.publish)}>
            {!isPublishing && <ShareAltOutlined />}
            {isPublishing && <LoadingSpinner />}
            Share
          </li>
          {(!isSocialDesign && !isLogo && !isA4 && !isDigitalMenuBoard && !isCustomSize) &&
            <li onClick={goToPrint}>
              {savingBeforePrint && <LoadingOutlined />}
              {!savingBeforePrint &&
                <div className='svg-cont'>
                  <svg>
                    <use xlinkHref={constants.appPrefix + "/svg/icons.svg#prints-icon"} />
                  </svg>
                </div>}
              Print
            </li>}
        </ul>
        <div className={'menu-separator'}></div>
        <ul className={'main'}>
          <li>
            <QuestionCircleOutlined/>
            <a href="https://intercom.help/musthavemenus-289b0117ae34/en" target="_blank">Help Center</a>
          </li>
          <li onClick={() => openChat()}>
            <MessageOutlined/>
            Chat with us
          </li>
        </ul>
      </div>

      <SaveModal customTitle={saveModalTitle} open={isSaveModal} saveMode={saveModalMode} quitAfterSaving={false} onModalClose={onSaveSuccess} />
    </div>
  )
}
